import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "our-select"
};
const _hoisted_2 = ["disabled"];
const _hoisted_3 = { class: "btn__label" };
const _hoisted_4 = { class: "btn__icon" };
const _hoisted_5 = ["open"];
const _hoisted_6 = { class: "our-select__list" };
const _hoisted_7 = ["disabled", "onClick"];
import { ref } from "vue";
import Sprite from "../../../components/Sprite.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Sorting',
    props: {
        type: { type: String, required: true },
        types: { type: Object },
        current: String,
        enabled: Boolean,
    },
    emits: ["change"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const open = ref(false);
        const emit = __emit;
        function select(code) {
            open.value = false;
            if (code !== props.type) {
                emit('change', code);
            }
        }
        return (_ctx, _cache) => {
            return (__props.enabled)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("button", {
                        class: "btn btn--m btn--4 btn--link our-select__current",
                        type: "button",
                        onClick: _cache[0] || (_cache[0] = ($event) => (open.value = !open.value)),
                        disabled: !__props.enabled
                    }, [
                        _createElementVNode("span", _hoisted_3, _toDisplayString(__props.current), 1 /* TEXT */),
                        _cache[1] || (_cache[1] = _createTextVNode()),
                        _createElementVNode("span", _hoisted_4, [
                            _createVNode(Sprite, { name: "arrow-down" })
                        ])
                    ], 8 /* PROPS */, _hoisted_2),
                    _cache[2] || (_cache[2] = _createTextVNode()),
                    _createElementVNode("dialog", {
                        class: "our-select__dialog",
                        open: open.value
                    }, [
                        _createElementVNode("ul", _hoisted_6, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.types, (title, code) => {
                                return (_openBlock(), _createElementBlock("li", {
                                    key: code,
                                    class: "our-select__item"
                                }, [
                                    _createElementVNode("button", {
                                        class: _normalizeClass(["our-select__btn", { 'is-selected': __props.type === code }]),
                                        type: "button",
                                        disabled: !__props.enabled,
                                        onClick: _withModifiers(($event) => (select(code)), ["prevent"])
                                    }, _toDisplayString(title), 11 /* TEXT, CLASS, PROPS */, _hoisted_7)
                                ]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ])
                    ], 8 /* PROPS */, _hoisted_5)
                ]))
                : _createCommentVNode("v-if", true);
        };
    }
});
